import React, { useEffect } from 'react';
import "../../styles/Services.css";
import GetInTouch from '../../components/GetInTouch';
const uiIcon1 = "/assets/icons/ui_icon_1.png";
const uiIcon2 = "/assets/icons/ui_icon_2.png";
const uiIcon3 = "/assets/icons/ui_icon_3.png";
const uiIcon4 = "/assets/icons/ui_icon_4.png";


const UIUXDesign = () => {
  useEffect(() => {
    document.title = 'UI/UX design | Inypeople';
  }, []);



  return (
    <>
     <section className="web-dev-section uiux-page">
  <div className="web-dev-container">
    <h1 className="web-dev-title">UI/UX Design</h1>
    <p className="uiux-description">
     At Inypeople, we design intuitive, visually compelling digital experiences your users love.

      Our human-centered approach blends aesthetics with functionality to drive satisfaction and conversion.
      <br />
      <br />
      With a strong focus on user behavior and business goals, we design experiences that drive adoption and
      conversions. From wireframes to final design, our UI/UX solutions are built to deliver consistency,
      accessibility, and delightful digital experiences across all platforms.
    </p>
  </div>

  <div className="circle circle-left"></div>
  <div className="circle circle-right"></div>
  <div className="circle circle-right-top"></div>
  <div className="circle circle-left-bottom"></div>
</section>


      <section className="services-section">
        <div className="services-container">
          <h2 className="services-main-title">Crafting smart UI/UX designs for seamless engagement.</h2>

          <div className="services-grid">

            <div className="service-card-wrapper">
              <div className="service-card">
                <div className="service-header">
                  <div className="service-icon">
                    <img
                      src={uiIcon1}
                      alt="Web Development Icon"
                      className="service-icon-img"
                    />
                  </div>

                  <h3 className="service-title">UI Design (Web & Mobile Interfaces)</h3>
                </div>

                <p className="service-description">
                  Create visually engaging and consistent interfaces across web and mobile platforms. Designs that reflect your brand while ensuring clarity, accessibility, and usability.
                </p>
              </div>
            </div>
            <div className="service-card-wrapper">
              <div className="service-card">
                <div className="service-header">
                  <div className="service-icon">
                    <img
                      src={uiIcon2}
                      alt="Web Development Icon"
                      className="service-icon-img"
                    />
                  </div>

                  <h3 className="service-title">UX Design for Web & Mobile Apps</h3>
                </div>
                <p className="service-description">
                  Design user-centric experiences driven by research and real user behavior. Focused on improving usability, engagement, and overall customer satisfaction.
                </p>
              </div>
            </div>
            <div className="service-card-wrapper">
              <div className="service-card">
                <div className="service-header">
                  <div className="service-icon">
                    <img
                      src={uiIcon3}
                      alt="Web Development Icon"
                      className="service-icon-img"
                    />
                  </div>

                  <h3 className="service-title">Design Systems & Style Guides</h3>
                </div>
                <p className="service-description">
                  Build scalable design systems that ensure consistency across all digital touchpoints. Comprehensive style guides streamline collaboration and future product development.
                </p>
              </div>
            </div>
            <div className="service-card-wrapper">
              <div className="service-card">
                <div className="service-header">
                  <div className="service-icon">
                    <img
                      src={uiIcon4}
                      alt="Web Development Icon"
                      className="service-icon-img"
                    />
                  </div>

                  <h3 className="service-title">Wireframing & Prototyping</h3>
                </div>
                <p className="service-description">
                  Visualize user journeys and application flow before development begins. Interactive wireframes and prototypes help validate ideas, reduce risks, and align stakeholders early.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Add GetInTouch at the bottom of this service page */}
      <GetInTouch />
    </>
  );
};

export default UIUXDesign;
